// extracted by mini-css-extract-plugin
module.exports = {"container":"addAndEditDept_container__38KnR"};